export default class Video {
	selectors = {
		cover: '.video-plus__cover',
		inner: '.video-plus__inner',
		hide: 'video-plus__wrapper--hide-cover',
		controls: '.video-plus__controls',
		reveal: 'video-plus__wrapper--reveal-video',
		message: 'cookieconsent-optout-marketing'
	};

	constructor( node ) {
		const { selectors: { inner, controls, message, cover } } = this;

		this.node = node;
		this.attempted = false;
		this.message = false;
		this.cover = this.node.querySelector(cover);
		this.inner = this.node.querySelector(inner);
		this.controls = this.node.querySelector(controls);
		this.player = this.node.querySelector('iframe') ?? this.node.querySelector('video');

		this.node.addEventListener('click', () => {
			this.attempted = true;
			this.onPlayClick();
		});

		this.cookieType = this.player.dataset.cookieconsent ?? null;
		window.addEventListener('CookiebotOnAccept', () => { this.onCookieBotAccept() } );
		this.onPlayClick();
	}

	onPlayClick() {
		const { selectors: { hide, reveal }, node, player } = this;
		const { contentWindow, dataset, playVideo } = player;
		const source = dataset.cookieblockSrc ?? dataset.src ?? player.src;

		if ( ! this.cookieCheck() ) {
			this.showMessage();
			console.error('Video disabled due to Cookiebot consent settings.', this.cookieType, source);
			return false;
		}

		const url = new URL(source);

		if (this.attempted) {
			node.classList.add(hide);
			node.classList.add(reveal);
		}

		if (contentWindow) {
			url.searchParams.append('enablejsapi', '1');
			if (this.attempted) {
				url.searchParams.append('autoplay', '1');
			}
			player.src = url.href;
			return contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
		}

		// If the button hasn't been clicked, we're performing a prefunctory
		// cookiecheck and swapping src attrs if appropriate.
		return this.attempted ? playVideo() : true;
	}

	showMessage() {
		const { selectors, message, node } = this;
		const el = document.createElement('div');

		el.classList.add(selectors.message );
		el.innerHTML = `<span>Please <a href="javascript:Cookiebot.renew()"> accept ${ this.cookieType ?? '' } cookies</a> to watch this video.</span>`;
		! message && node.append(el);

		this.message = el;
	}

    cookieCheck() {
		try {
			if ( ! window?.Cookiebot?.consent || ! this.cookieType ) {
				// if cookiebot doesn't exist - act as if all things are allowed
				return true;
			}

			return window.Cookiebot.consent[ this.cookieType ];
		} catch ( fault ) {
			return false;
		}
    }

	onCookieBotAccept() {
		if ( ! this.cookieCheck() ) {
			return this.showMessage();
		}

		return this.attempted && this.onPlayClick();
	}
}

const videos = document.getElementsByClassName('video-plus__wrapper') ?? [];
[...videos].map((vid) => { return new Video(vid); });
